import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { KeycloakService } from 'keycloak-angular';
import { catchError, forkJoin, from, of } from 'rxjs';

export const initialDataResolver = () => {
    const navigationService = inject(NavigationService);
    const keycloakService = inject(KeycloakService);

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([navigationService.get(), from(keycloakService.loadUserProfile()).pipe(catchError(() => of(null)))]);
};
